<template>
  <div class="accommodation-quick-view">
    <div class="accommodation-quick-view_header">
      <span class="accommodation-quick-view_title">{{categoryData.title}}</span>
    </div>

    <div class="accommodation-quick-view_body">
      <div class="accommodation-quick-view_equipment">
        <div class="room-status accommodation-quick-view_class">
          <room-label
            :name="categoryData.description"
            :icon="categoryIcons[categoryData.id]"
          >
          </room-label>
        </div>

        <span class="accommodation-quick-view_equipment-title">Оснащение номера:</span>
        <ul class="accommodation-quick-view_equipment-list">
          <li
            class="accommodation-quick-view_equipment-item"
            v-for="feature, i in categoryData.features"
            :key="i"
          >
            <div class="accommodation-quick-view_equipment-icon">
              <img class="accommodation-quick-view_equipment-icon-img" :src="require(`@/assets/img/category-features/${feature.code}.svg`)" :alt="feature.name">
            </div>
            <span class="accommodation-quick-view_equipment-item-text">{{feature.name}}</span>
          </li>
        </ul>
      </div>

      <div class="accommodation-quick-view_carousel">
        <ui-carousel
          :slidesImg="categoryData.images"
          :slidesToShow="2"
          :infinite="true"
        >
        </ui-carousel>

      </div>
    </div>

    <ul class="accommodation-quick-view_info">
      <!-- <li class="accommodation-quick-view_info-item">
        <span class="accommodation-quick-view_info-name">Размещение</span>
        <span class="accommodation-quick-view_info-val">{{dispMaxPersonsCnt}}</span>
      </li> -->
      <li class="accommodation-quick-view_info-item">
        <span class="accommodation-quick-view_info-name">Количество мест</span>
        <span class="accommodation-quick-view_info-val">{{dispPlaces}}</span>
      </li>
      <li class="accommodation-quick-view_info-item">
        <span class="accommodation-quick-view_info-name">Площадь номера</span>
        <span class="accommodation-quick-view_info-val">{{categoryData.square}} кв.м</span>
      </li>
    </ul>

    <div class="accommodation-quick-view_footer">
      <div
        class="accommodation-quick-view_totals"
        v-if="+variantData.price > 0"
      >
        <span class="accommodation-quick-view_totals-text">Итого:</span>
        <span class="accommodation-quick-view_totals-value">{{dispPrice}}</span>
      </div>

      <a
        href="javascript:void(0)"
        class="accommodation-quick-view_check-price"
        @click.prevent="selectVariant"
        v-else
      >
        Узнать цену
      </a>

      <div class="accommodation-quick-view_actions">
        <a class="ui-btn accommodation-quick-view_action" @click.prevent="selectVariant">Выбрать</a>
      </div>
    </div>
  </div>
</template>

<script>
import RoomLabel from '@/components/RoomLabel'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'accommodation-quick-view',

  components: {
    RoomLabel,
  },

  props: {
    variantData: {
      type: Object,
      required: true,
    }
  },

  data: () => ({
  }),

  computed: {
    ...mapState({
      categoryIcons: state => state.dictionaries.categoryIcons,
      featuresIcons: state => state.dictionaries.featuresIcons
    }),

    ...mapGetters({
      getCategoryById: 'dictionaries/getRoomCategoryById',
    }),

    categoryData() {
      return this.getCategoryById(this.variantData.roomCategoryId)
    },

    dispMaxPersonsCnt() {
      let str = `до ${this.data.maxPersons} человек`
      if(this.data.maxPersons % 10 === 1 && this.data.maxPersons !== 11) str += `а`
      return str
    },

    dispPrice() {
      return `${String(this.variantData.price).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')} р`
    },

    dispPlaces() {
      let cnt = +this.categoryData.capacity + +this.categoryData.capacityExtra
      return `${cnt}`
    }
  },

  methods: {
    selectVariant() {
      // console.log('fsdaaaaaaa')
      this.$emit('selectVariant')
    },
  },

  mounted() {
    // console.log(this.id)
  }
}

// const responseTemplate = {
//   name: '1к стандартный двухместный номер',
//   category: {
//     icon: require('@/assets/img/room-statuses/status-izumrud.png'),
//     text: '1-м Изумруд, Рубин'
//   },
//   features: [
//     {icon: require('@/assets/icons/room-feature-icon-2.png'), text: 'Wi-Fi бесплатно'},
//     {icon: require('@/assets/icons/room-feature-icon-3.png'), text: 'Электрочайник'},
//     {icon: require('@/assets/icons/room-feature-icon-1.png'), text: 'Спутниковое телевидение'},
//     {icon: require('@/assets/icons/room-feature-icon-4.png'), text: 'Солнечная сторона'},
//     {icon: require('@/assets/icons/room-feature-icon-5.png'), text: 'Телефон'},
//     {icon: require('@/assets/icons/room-feature-icon-6.png'), text: 'Радио / музыкальный центр'},
//     {icon: require('@/assets/icons/room-feature-icon-7.png'), text: 'Холодильник'},
//     {icon: require('@/assets/icons/room-feature-icon-8.png'), text: 'Вид на фонтан'},
//   ],
//   imgs: [
//     {path: require('@/assets/img/accommodation-quick-view/img-1.png'), alt: 'photo 1'},
//     {path: require('@/assets/img/accommodation-quick-view/img-2.png'), alt: 'photo 2'},
//     {path: require('@/assets/img/accommodation-quick-view/img-1.png'), alt: 'photo 3'},
//     {path: require('@/assets/img/accommodation-quick-view/img-1.png'), alt: 'photo 4'},
//   ],
//   maxPersons: 3,
//   places: '2 односпальные кровати и 1 диван-кровать',
//   square: 30,
//   price: 20650,
// }
</script>

<style lang="sass">
.accommodation-quick-view
  width: 100%
  font-size: 1rem
  color: rgba(105, 109, 116, 1)
  padding: px-em(40) px-em(48) px-em(56) px-em(39)
  background-color: #fff
  outline: 1px solid red

.accommodation-quick-view_header
  margin-bottom: px-em(34)

.accommodation-quick-view_title
  display: block
  font-weight: 700
  font-size: 1.125em
  color: rgba(26, 71, 69, 1)

.accommodation-quick-view_body
  width: 100%
  display: flex
  margin-bottom: px-em(36)

.accommodation-quick-view_equipment
  min-width: 1px
  flex-grow: 1
  position: relative
  margin-right: px-em(24)

.accommodation-quick-view_class
  position: absolute
  top: 0
  right: 0
  margin-top: px-em(-14)

.accommodation-quick-view_equipment-title
  display: block
  font-size: 1.125em
  margin-bottom: px-em(25, 18)

.accommodation-quick-view_equipment-list
  list-style: none
  padding: 0
  margin: 0

.v-application .accommodation-quick-view_equipment-list
  padding: 0
  margin: 0

.accommodation-quick-view_equipment-item
  padding-left: px-em(54)
  position: relative

  + .accommodation-quick-view_equipment-item
    margin-top: px-em(23)

.accommodation-quick-view_equipment-icon
  width: px-em(31)
  height: px-em(31)
  display: flex
  align-items: center
  justify-content: center
  position: absolute
  top: 0
  left: 0
  margin-top: px-em(-8)

.accommodation-quick-view_equipment-icon-img
  flex-shrink: 0
  max-width: 100%

.accommodation-quick-view_carousel
  width: px-em(370)
  flex-shrink: 0

.v-application .accommodation-quick-view_info
  margin: 0
  padding: 0

.accommodation-quick-view_info
  margin: 0
  padding: 0
  list-style: none
  width: 100%

.accommodation-quick-view_info-item
  width: 100%
  display: flex
  justify-content: space-between
  position: relative
  background-color: #fff

  + .accommodation-quick-view_info-item
    margin-top: px-em(36)

  &::after
    content: ""
    display: block
    position: absolute
    bottom: 0
    left: 0
    right: 0
    height: 1px
    transform: translateY(px-em(-2))
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='1' fill='none' viewBox='0 0 11 1'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath fill='%238A8A8A' fill-rule='evenodd' d='M0 .5C0 .224.231 0 .516 0h3.742c.285 0 .516.224.516.5s-.23.5-.516.5H.516A.508.508 0 0 1 0 .5Zm11.226 0c0-.276.23-.5.516-.5h3.742c.285 0 .516.224.516.5s-.231.5-.516.5h-3.742a.508.508 0 0 1-.516-.5Z' clip-rule='evenodd'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h11v1H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
    background-repeat: repeat-x
    background-position: 0
    background-size: contain

.accommodation-quick-view_info-name,
.accommodation-quick-view_info-val
  background-color: inherit
  z-index: 1

.accommodation-quick-view_footer
  width: 100%
  display: flex
  justify-content: space-between
  margin-top: px-em(37)

.accommodation-quick-view_totals
  flex-shrink: 0
  vertical-align: baseline

.accommodation-quick-view_totals-value
  font-size: px-em(35)
  font-weight: 700
  color: #1A4745
  margin-left: px-em(20)
  line-height: 1.2

.accommodation-quick-view_actions

.accommodation-quick-view_check-price
  // font-weight: 500
  align-self: center
  font-size: px-em(20)


</style>


